import React from 'react';
import c from 'classnames';

import { WasteIcon } from '@hvcgroep/design-system';

interface Props {
  title: string
  dateLabel: string
  wasteStreamId: number
}

const CalendarItemPickupMoment: React.FC<Props> = ({ title, dateLabel, wasteStreamId }) => {
  const classes = c('CalendarItem', 'CalendarItem--pickupMoment');

  return (
    <div className={classes} title={title}>
      <span className="sr-only">
        {`${dateLabel} ${title}`}
      </span>
      <WasteIcon streamId={wasteStreamId} alt="" />
    </div>
  );
};

export default CalendarItemPickupMoment;
